<template>
  <div>
    <h4 class="my-4">{{ title }}</h4>
    <div
      v-for="(questionData, index) in questions"
      :key="index"
      class="d-flex align-center mb-2"
    >
      <v-chip>
        <span class="font-weight-bold">
          {{ index + 1 }}
        </span>
      </v-chip>
      <div>
        {{ questionData.question }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    questions: Array
  }
};
</script>
